module.exports = __webpack_public_path__ + "static/img/subway-02.40910a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-02.png
// module id = 147
// module chunks = 0